import { render, staticRenderFns } from "./ColorMagnifier.vue?vue&type=template&id=8cac5836&"
import script from "./ColorMagnifier.vue?vue&type=script&lang=ts&"
export * from "./ColorMagnifier.vue?vue&type=script&lang=ts&"
import style0 from "./ColorMagnifier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports